function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M113.3,52.7h54c3.7,0,6.8-3,6.8-6.7c0-3.7-3-6.8-6.7-6.8c0,0,0,0,0,0h-54c-3.7,0-6.8,3-6.8,6.8 S109.5,52.7,113.3,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M167.2,60H97.4c-1.2-4-2.3-8.1-3.3-12.3C90.7,33.4,88.9,26.2,82,26.2H32.2 c-10.9,0-19.7,10.4-19.7,23.1v101.2c0,12.8,8.8,23.1,19.7,23.1h135c10.9,0,19.7-10.4,19.7-23.2V83.1C187,70.4,178.1,60,167.2,60z  M174.5,150.6c0,5.8-3.3,10.6-7.2,10.6h-135c-3.9,0-7.2-4.9-7.2-10.6V49.4c0-5.8,3.3-10.6,7.2-10.6h46.5c1,2.9,2.3,8.2,3.2,11.9 c3.5,14.5,5.3,21.8,12.2,21.8h73.1c3.9,0,7.2,4.9,7.2,10.6L174.5,150.6L174.5,150.6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.1f510cd4a72dc575692ff74d62afc608.svg";
export { ForwardRef as ReactComponent };